import React from 'react';
import DashboardLayout from '../../layouts/DashboardLayout';
import { ProtectedRoute } from '../components/ProtectedRoute';

/**
 * Persistent dashboard shell: sidebar + topbar stay mounted;
 * only the <Outlet /> page region updates on navigation.
 */
export function DashboardShell() {
  return (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  );
}
